import { addHook } from '@viveaesthetics/elemy-shared-core'
import { useControlUrlParams as useControlUrlParamsShared } from '@viveaesthetics/shared-domain'

import { ProviderFilterTypes } from '@/types/providers'

import { useRouter } from './useRouter'

const defaultParams: Required<ProviderFilterTypes> = {
  concern: [],
  day: [],
  gender: [],
  identity: [],
  // Todo: remove with 'pedp-3858-booking-insurance-id'
  insurance: '',
  insuranceId: '',
  cash_payment: '',
  pageIndex: '',
  state: '',
  city: '',
  test: '',
  time: [],
  typeOfCare: '',
  time_slot: ''
}

export const useControlUrlParams = addHook({
  useControlUrlParams: () =>
    useControlUrlParamsShared<ProviderFilterTypes>(defaultParams, useRouter)
})
